import { Workbox } from "workbox-window";

/**
 * Register the service worker
 * @returns {Promise<Workbox|null>} The Workbox instance or null if not supported
 */
export async function registerServiceWorker() {
    if (!("serviceWorker" in navigator)) {
        console.log("Service Worker not supported");
        return null;
    }

    // Add version parameter to force cache bust on service worker updates
    const SW_VERSION = "1.0.8"; // Update this when you want to force SW update
    const wb = new Workbox(`/app/service-worker.js?v=${SW_VERSION}`);

    // Listen for waiting service worker
    wb.addEventListener("waiting", (event) => {
        console.log("New service worker waiting to activate");

        // Automatically activate the new service worker
        // This ensures users always get the latest version
        wb.messageSkipWaiting();

        // Optional: Show a brief notification to the user
        // (you can remove this if you want completely silent updates)
        if (window.Notification && Notification.permission === "granted") {
            new Notification("Mise à jour disponible", {
                body: "L'application va se recharger pour appliquer la mise à jour.",
                icon: "/app/icons/manifest-icon-192.png",
            });
        }
    });

    // Listen for controlling event (service worker activated)
    wb.addEventListener("controlling", (event) => {
        console.log("New service worker activated - forcing hard reload");
        // Use hard reload to bypass any remaining cache
        window.location.reload(true);
    });

    // Listen for activated event
    wb.addEventListener("activated", (event) => {
        console.log("Service Worker activated");

        // If it's not the first activation, reload the page
        if (!event.isUpdate) {
            console.log("Service Worker activated for the first time");
        } else {
            console.log("Service Worker updated");
        }
    });

    try {
        await wb.register();
        console.log("Service Worker registered successfully");

        // Check for updates every 30 minutes
        setInterval(() => {
            wb.update();
            console.log("Checking for service worker updates...");
        }, 30 * 60 * 1000); // 30 minutes

        // Also check for updates when the page becomes visible again
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
                wb.update();
                console.log("Page visible - checking for updates...");
            }
        });

        return wb;
    } catch (error) {
        console.error("Service Worker registration failed:", error);
        return null;
    }
}

/**
 * Trigger manual sync (useful for sync button)
 */
export function triggerSync() {
    if ("serviceWorker" in navigator && "sync" in navigator.serviceWorker) {
        navigator.serviceWorker.ready
            .then((registration) => {
                return registration.sync.register("sync-data");
            })
            .then(() => {
                console.log("Background sync registered");
            })
            .catch((err) => {
                console.error("Background sync registration failed:", err);
            });
    } else {
        console.log(
            "Background Sync not supported, falling back to manual sync",
        );
        // Fallback: trigger sync event via message
        if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({
                type: "SYNC_NOW",
            });
        }
    }
}

/**
 * Check if the app is running in standalone mode (installed as PWA)
 */
export function isStandalone() {
    return (
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true
    );
}

/**
 * Check if the device is online
 */
export function isOnline() {
    return navigator.onLine;
}
